import request from '@/api/axios';

// 图片上传
const uploadImg = (params: object) => {
    params.folderId = 2;
    // params.isWatermark = false
    return request({
        url: '/system/pic/upload',
        method: 'post',
        data: params,
    });
};

// 企业认证工作证明图片上传接口(带压缩图片功能)
const uploadCertificationImg = (params: object) => {
    return request({
        url: '/system/enterpriseCertification/uploadCertificationImg',
        method: 'post',
        data: params,
    });
};

// 个人信息详情
const getUserDetail = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/crm/api/id',
        url: '/user/center/api/id', // 更新二期接口
        method: 'get',
        data: params,
    });
};

// 更新信息
const getUserUpdate = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/crm/api/update',
        url: '/user/center/api/update', // 更新二期接口
        method: 'put',
        data: params,
    });
};

// 根据用户id获取最后一次认证通过的信息
const getLastPassByUserId = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/crm/api/id',
        url: '/oms/center/inner_api/certificationInfo/getLastPassByUserId', // 更新二期接口
        method: 'get',
        data: params,
    });
};

// 验证手机号码
const userNameChoose = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/crm/api/username/verify',
        url: '/user/center/api/username/verify',
        method: 'get',
        data: params,
    });
};

// 更换手机号码
const oldPhone = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/user/center/api/old/username/verify',
        // url: '/crm/api/old/username/verify',
        method: 'post',
        data: params,
    });
};
const newPhone = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/user/center/api/new/username/verify',
        // url: '/crm/api/new/username/verify',
        method: 'post',
        data: params,
    });
};

//申请企业认证
const applyCompany = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/system/enterpriseCertification/add',
        url: '/oms/center/enterpriseCertification/add', // 二期接口
        method: 'post',
        data: params,
    });
};

//重新申请企业认证
const reApplyCompany = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/system/enterpriseCertification/again',
        url: '/oms/center/enterpriseCertification/again', // 二期接口
        method: 'post',
        data: params,
    });
};

//企业认证详情
const applyCompanyDetail = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/system/enterpriseCertification/details',
        url: '/oms/center/enterpriseCertification/details', // 二期接口
        method: 'get',
        data: params,
    });
};

//获取企业认证职位数据
const getPostions = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/user/center/api/dict/type/', // 二期接口
        method: 'get',
        data: params,
        // url: '/system/dict/data/listByTypeCode/' + params,
    });
};

// 品牌专区
const applyCustomer = (params: object) => {
    return request({
        url: '/crm/brandRequire/save',
        method: 'post',
        data: params,
    });
};
// 供应商合作
const applyCustomerSettle = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/merchantSettlement/save',
        method: 'post',
        data: params,
    });
};

// 方案定制
const applyService = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/schemeCustomization/save',
        method: 'post',
        data: params,
    });
};

// 技术服务
const applyTechnology = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/technicalService/add',
        method: 'post',
        data: params,
    });
};

// 获取技术服务
const getTechnology = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/technicalService/page',
        method: 'post',
        data: params,
    });
};

//获取技术服务详情
const getTechnologyDetail = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/technicalService/details',
        method: 'get',
        data: params,
    })
};

// 获取积分列表
const getIntegralList = (params: object) => {
    return request({
        url: '/integral/user/page',
        method: 'get',
        data: params,
    });
};

// 是否收藏商品
const getCollectExist = (params: object) => {
    return request({
        url: '/product/collect/isExist',
        method: 'get',
        data: params,
    });
};
// 收藏商品
const addCollection = (params: object) => {
    return request({
        url: '/product/collect/save',
        method: 'post',
        data: params,
    });
};
// 获取收藏
const getCollect = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/commodity/center/collect/pageByUser',
        method: 'post',
        data: params,
    });
};
// 删除
const deleteCollect = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/commodity/center/collect/remove',
        method: 'delete',
        data: params,
    });
};

// 是否已经加入对比
const getContrastExist = (params: object) => {
    return request({
        url: '/product/compare/isExist',
        method: 'get',
        data: params,
    });
};
// 对比商品
const addContrast = (params: object) => {
    return request({
        url: '/product/compare/save',
        method: 'post',
        data: params,
    });
};
// 对比列表
const getContrastList = (params: object) => {
    params.isApi2 = true;
    return request({
        url: '/commodity/center/compare/list',
        method: 'get',
        data: params,
    });
};
// 删除对比商品
const deletecontrast = (params: object) => {
    return request({
        url: '/product/compare/remove',
        method: 'post',
        data: params,
    });
};
// 清空对比栏
const clearcontrast = (params: object) => {
    return request({
        url: '/product/compare/empty',
        method: 'get',
        data: params,
    });
};

// 足迹管理
const getFootmark = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/commodity/center/footmark/month',
        method: 'get',
        data: params,
    });
};
// 删除足迹
const deleteFootmark = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/commodity/center/footmark/remove',
        method: 'delete',
        data: params,
    });
};

// 获取全部优惠卷
const getCoupons = (params: object) => {
    return request({
        url: '/coupon/user/page',
        method: 'get',
        data: params,
    });
};

// 获取全部优惠卷
const getBillDe4tails = (params: object) => {
    return request({
        url: '/order/bill/order/sn',
        method: 'get',
        data: params,
    });
};

// 消息分页
const getMeaasgePage = (params: object) => {
    return request({
        url: '/system/notice/page',
        method: 'get',
        data: params,
    });
};

// 消息批量已读
const getMeaasgeRead = (params) => {
    return request({
        url: '/system/notice/read',
        method: 'post',
        data: params,
    });
};
// 消息详情
const getMesageDetail = (params: object) => {
    return request({
        url: '/system/notice/detail',
        method: 'get',
        data: params,
    });
};
// 消息删除
const deletaMesage = (params: object) => {
    return request({
        url: '/system/notice/remove',
        method: 'delete',
        data: params,
    });
};

// 查询用户申请分页
const applyPage = (params: object) => {
    return request({
        url: '/crm/apply/page',
        method: 'get',
        data: params,
    });
};

// 询价询交期列表
const getConsultPage = (params: object) => {
    params.isApi2 = true
    return request({
        // url: '/order/procureConsult/pageList',
        url: '/service/center/procureConsult/pageList',
        method: 'post',
        data: params,
    });
};
// 询价询交期详情
const getConsultDetail = (id) => {
    return request({
        // url: '/order/procureConsult/detail',
        url: '/service/center/procureConsult/detail',
        method: 'get',
        data: {
            isApi2: true,
            id: id,
        },
    });
};

// 获取上下篇文章
export const contentNextOrPrev = (params: object) => {
    return request({
        url: '/product/api/customization/nextOrPrev',
        method: 'post',
        data: params,
    });
};

// 产品定制列表
const getCustomizationList = (params: object) => {
    return request({
        url: '/product/api/customization/page',
        method: 'get',
        data: params,
    });
};
// 产品定制列表
const getCustomizationPage = (params: object) => {
    return request({
        url: '/order/orderCustomization/pc/page',
        method: 'get',
        data: params,
    });
};
const getCustomizationDetail = (id: string) => {
    return request({
        url: '/order/orderCustomization/details',
        method: 'get',
        data: {
            id: id,
        },
    });
};

const getContentDetail = (id: string) => {
    return request({
        url: '/product/api/customization/detail',
        method: 'get',
        data: {
            id: id,
        },
    });
};

//智能客服-关联问题换一换
const changeQuestion = (params: object) => {
    return request({
        url: '/im/gsCustomerFaq/pageRelation',
        method: 'post',
        data: params,
    });
};

//智能客服-全部问题换一换
const changeAllQuestion = (params: object) => {
    return request({
        url: '/im/gsCustomerFaq/page',
        method: 'post',
        data: params,
    });
};

//转接人工客服
const switchFae = () => {
    return request({
        url: '/im/conversation/staff/create',
        method: 'post',
    });
};

//游客聊天记录合并
export const chatTransfer = (params: object) => {
    return request({
        url: '/im/conversation/visitor',
        method: 'get',
        data: params,
    });
};

//开启/关闭消息提示音
export const OpenMusic = (params: object) => {     
    return request({
        url: '/im/userAccount/userAudio',
        method: 'get',
        data: params,
    });
};

// 品牌列表
const getBrandList = (params: object) => {
    return request({
        url: '/crm/brandRequire/getPageByUser',
        method: 'post',
        data: params,
    });
};
const getBrandDetail = (id: string) => {
    return request({
        url: '/crm/brandRequire/detail',
        method: 'get',
        data: {
            id: id,
        },
    });
};
// 供应商合作列表
const getSettleList = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/merchantSettlement/getPageByUser',
        method: 'post',
        data: params,
    });
};

const getSettleDetail = (id: string) => {
    const params = {
        id:id,
        isApi2:true
    }
    return request({
        url: '/service/center/merchantSettlement/detail',
        method: 'get',
        data: params,
    });
};
// 方案定制列表
const getServiceList = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/schemeCustomization/getPageByUser',
        method: 'post',
        data: params,
    });
};

const getServiceDetail = (id: string) => {
    const params = {
        id:id,
        isApi2:true
    }
    return request({
        url: '/service/center/schemeCustomization/detail',
        method: 'get',
        data: params,
    });
};

// 获取我的消息
const getNotifylog = (params) => {
    params.isApi2 = true
    return request({
        url: '/user/center/message/info/client/page',
        method: 'post',
        data: params,
    });
};

// 更新读取状态
const setUpdateRead = (params) => {
    params.isApi2 = true
    return request({
        url: '/user/center/message/info/read/batchUpdate',
        method: 'post',
        data: params,
    });
};

// 获取短信订阅的列表数据
const getSubConfigPage = (params) => {
    params.isApi2 = true
    return request({
        url: '/user/center/msg/subConfig/page',
        method: 'post',
        data: params,
    });
};

// 批量更新短信订阅
const updateBatch = (params) => {
    params.isApi2 = true
    return request({
        url: '/user/center/msg/subConfig/update',
        method: 'post',
        data: params,
    });
};

// 我的消息，未读数量状态统计 （按业务类型分组）
const getReadStatusCountByBizGroup = (params) => {
    params.isApi2 = true
    return request({
        url: '/user/center/message/info/client/count',
        method: 'get',
        data: params,
    });
};

// 定制服务，定制厂商推荐列表
const getCustomSensorRecommendList = () => {
    return request({
        url: '/product/api/customization/customSensorRecommendList',
        method: 'get',
    });
};

// 定制服务，模块方案推荐推荐列表
const getSolutionRecommendList = () => {
    return request({
        url: '/cms/center/api/content/solutionRecommendList',
        method: 'get',
        data: {
            isApi2: true
        },
    });
};

// 样品活动, 分页列表 
const getUserApplyPageList = (params) => {
    params.isApi2 = true
    return request({
        url: '/oms/center/sample/activity/apply/userApplyPageList',
        method: 'POST',
        data: params,
    });
};

// 样品活动详情 
const getApplyDetail = (id: string) => {
    return request({
        url: `/oms/center/sample/activity/apply/detail/${id}`,
        method: 'get',
        data: {
            isApi2:true
        },
    });
};

// 样品申请, 分页列表 
const getSampleOrderList = (params) => {
    params.isApi2 = true
    return request({
        url: '/service/center/sampleOrder/pageList',
        method: 'POST',
        data: params,
    });
};

// 样品申请详情 
const getSampleOrderDetail = (id: string) => {
    return request({
        url: `/service/center/sampleOrder/detail?id=${id}`,
        method: 'get',
        data: {
            isApi2:true
        },
    });
};

// 根据申请ID获取申请邮箱
const getFullEmail = (applyId)=> {
    return request({
        url: `/oms/center/activity/sample/apply/fetch/email?applyId=${applyId}`,
        method: 'get',
        data: {
            isApi2:true
        },
    })
}

// 根据申请ID获取申请手机号
const getFullPhone = (applyId)=> {
    return request({
        url: `/oms/center/activity/sample/apply/fetch/phone?applyId=${applyId}`,
        method: 'get',
        data: {
            isApi2:true
        },
    });
}


// 样品活动, 用户提交样品活动报名中的收货地址
const userSubmitReceiveAddress = (params) => {
    return request({
        url: '/market/activity/sample/userSubmitReceiveAddress',
        method: 'post',
        data: params,
    });
};

// 优惠券, 查询用户的优惠券分页列表
const getUserCouponPageList = (params) => {
    params.isApi2 = true
    return request({
        url: '/oms/center/coupon/userPageList',
        method: 'post',
        data: params,
    });
};

// 查询用户优惠券详情
const getCouponDetail = (userCouponId: string) => {
    return request({
        url: '/oms/center/userCoupon/detail',
        method: 'get',
        data: {
            userCouponId,
            isApi2: true
        },
    });
};

//订货服务 
const getorderingGoodsService = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/orderingGoodsService/user/pageList',
        method: 'post',
        data: params,
    });
};

//订货服务-详情
const getorderingGoodsDtails = (params: object) => {
    params.isApi2 = true
    return request({
        url: '/service/center/orderingGoodsService/detail',
        method: 'get',
        data: params,
    });
};
//获取一级行业分类
const getindustry1page = () => {
    return request({
        url: "/cms/industryApplication/getAllLevel1",
        method: "get",
    });
};

//注销业务检查
const getLogoutStatus = (params) =>{
    params.isApi2 = true
    return request({
        // url: '/system/user/deregistered/bizCheck',
        url: '/user/center/api/deregistered/bizCheck', // 二期接口
        method: 'POST',
        data: params,
    });
}

//获取注销验证码
const getLogoutCode = (params) =>{
    params.isApi2 = true
    return request({
        // url: '/system/user/deregistered/smsValidateCode',
        url: '/user/center/api/deregistered/smsValidateCode', // 二期接口
        method: 'POST',
        data: params,
    });
}

//确认注销
const logoutConfirm = (params) =>{
    params.isApi2 = true
    return request({
        // url: '/system/user/deregistered/confirm',
        url: '/user/center/api/deregistered/confirm', // 二期接口
        method: 'POST',
        data: params,
    });
}

// 提交认证(二期接口)
const enterpriseCertificationAdd = (params) =>{
    params.isApi2 = true
    return request({
        url: '/oms/center/enterpriseCertification/add',
        method: 'POST',
        data: params,
    });
}

// 天眼查(二期接口)
const search816 = (params) =>{
    params.isApi2 = true
    return request({
        url: '/user/center/api/tianyancha/search',
        method: 'POST',
        data: params,
    });
}

// 邮箱后缀匹配(二期接口)
const emailMatch = (params) =>{
    params.isApi2 = true
    return request({
        url: '/oms/center/emailManagement/emailMatch',
        method: 'GET',
        data: params,
    });
}
// 用户企业认证，邮箱验证发送
const enterpriseCertification = (params) =>{
    params.isApi2 = true
    return request({
        url: '/user/center/email/enterpriseCertification',
        method: 'GET',
        data: params,
    });
}

//行为记录
const behaviorRecord = (code,params) =>{
    params.isApi2 = true
    return request({
        url: '/statistic/center/api/pic/'+ code,
        method: 'GET',
        data: params,
    });
}


let minesApi = {
    uploadImg,
    uploadCertificationImg,
    getUserDetail,
    getUserUpdate,
    userNameChoose,
    oldPhone,
    newPhone,
    applyCompany,
    reApplyCompany,
    applyCompanyDetail,
    getPostions,
    applyCustomer,
    getIntegralList,
    getCollect,
    getCollectExist,
    addCollection,
    deleteCollect,
    getContrastExist,
    addContrast,
    getContrastList,
    deletecontrast,
    clearcontrast,
    getFootmark,
    deleteFootmark,
    getCoupons,
    getBillDe4tails,
    getMeaasgePage,
    getMeaasgeRead,
    getMesageDetail,
    deletaMesage,
    applyPage,
    getConsultPage,
    getConsultDetail,
    getCustomizationPage,
    getContentDetail,
    getCustomizationDetail,
    getCustomizationList,
    changeQuestion,
    changeAllQuestion,
    switchFae,
    chatTransfer,
    OpenMusic,
    applyService,
    applyTechnology,
    getTechnology,
    getTechnologyDetail,
    applyCustomerSettle,
    getBrandList,
    getSettleList,
    getServiceList,
    getSettleDetail,
    getBrandDetail,
    getServiceDetail,
    getNotifylog,
    setUpdateRead,
    getSubConfigPage,
    updateBatch,
    getReadStatusCountByBizGroup,
    contentNextOrPrev,
    getCustomSensorRecommendList,
    getSolutionRecommendList,
    getUserApplyPageList,
    getApplyDetail,
    getSampleOrderList,
    getSampleOrderDetail,
    getFullPhone,
    getFullEmail,
    userSubmitReceiveAddress,
    getUserCouponPageList,
    getCouponDetail,
    getorderingGoodsService,
    getorderingGoodsDtails,
    getindustry1page,
    getLogoutStatus,
    getLogoutCode,
    logoutConfirm,
    enterpriseCertificationAdd,
    search816,
    emailMatch,
    enterpriseCertification,
    getLastPassByUserId,
    behaviorRecord
};

export default minesApi;
